module.exports = __webpack_public_path__ + "static/marcin-79531794e8a3f5569b23021e2e381408.jpg";